import { SyncLoader } from "react-spinners";
import MinimarLogo from "./MinimarLogo/MinimarLogo";
import React, { useEffect } from "react";
import clsx from "clsx";
import { useLocation } from "react-router-dom";

interface GlobeLoadingProps {
    isLoading?: boolean;
}

const GlobeLoading: React.FC<GlobeLoadingProps> = (props) => {
    const ref = React.useRef<HTMLDivElement>(null);
 
    const location = useLocation();


    useEffect(() => {
        if (props.isLoading) {
            ref.current?.style.setProperty("display", "flex");
            document.body.style.setProperty("overflow", "hidden");
        }
        else {
            document.body.style.setProperty("overflow", "auto");
            ref.current?.classList.add("fade-out");
            setTimeout(() => {
                ref.current?.classList.remove("fade-out");
                ref.current?.style.setProperty("display", "none");
            }, 1500);
        }
    }, [props.isLoading]);

    useEffect(() => {
        document.scrollingElement?.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <div
            ref={ref}
            className={
                clsx("loader")
            }>
            <MinimarLogo />
            <br />
            <SyncLoader
                color={"#007bff"}
                loading={true}
                size={15}
            />
        </div>
    );
}
export default GlobeLoading;